import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE_NAME = '/api/employees';

export default {
    getRole(employeeId) {
        return Api().get(`${RESOURCE_NAME}/${employeeId}/role`)
            .catch((err) => errorHandler(err, null));
    },
    updateRole(employeeId, role) {
        return Api().put(`${RESOURCE_NAME}/${employeeId}/role`, { role })
            .catch((err) => errorHandler(err, null));
    },
}
